import React from "react";

const ContentContainer = ({ children }) => {
  return <div className="max-w-7xl mx-auto px-4 py-6">{children}</div>;
};

export default ContentContainer;
